import React, { useEffect, useState } from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

import styles from './yesNo.style';

const YesNo = ({ value, onChange, disabled, name }) => {
  const [stringValue, setStringValues] = useState(value?.toString() || 'false');

  useEffect(() => {
    setStringValues(value?.toString() || 'false');
  }, [value]);

  const _handleChange = (event) => {
    // eslint-disable-next-line no-unneeded-ternary
    onChange(event.target.value === 'true' ? true : false);
  };

  return (
    <ToggleButtonGroup
      color="primary"
      value={stringValue}
      exclusive
      onChange={_handleChange}
      aria-label="yes-no"
      sx={styles.group}
      data-testid={`input-${name || 'yes-no'}`}
    >
      <ToggleButton value="true" sx={styles.button} disabled={disabled}>
        Yes
      </ToggleButton>
      <ToggleButton value="false" sx={styles.button} disabled={disabled}>
        No
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default YesNo;
